import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DefaultSwitch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';

const propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number,
  ]),
  checkedValue: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number,
  ]),
  uncheckedValue: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func,
};

const defaultProps = {
  label: '',
  value: false,
  checkedValue: true,
  uncheckedValue: false,
  onChange: null,
};

function Switch(props) {
  const {
    label, value, checkedValue, uncheckedValue, onChange, ...others
  } = props;
  const [isChecked, setChecked] = React.useState(false);

  React.useEffect(() => {
    if (value === checkedValue) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [value]);

  const handleChange = (event) => {
    const { name } = event.target;
    const newValue = event.target.checked ? checkedValue : uncheckedValue;
    const customEvent = {
      target: {
        name,
        value: newValue,
      },
    };
    onChange(customEvent);
  };

  const formControlProps = {
    margin: 'normal',
    fullWidth: false,
  };

  return (
    <Grid container>
      <FormControl {...formControlProps}>
        <FormControlLabel
          control={(
            <DefaultSwitch
              checked={isChecked}
              onChange={handleChange}
              value={value}
              {...others}
            />
          )}
          label={label}
        />
      </FormControl>
    </Grid>
  );
}

Switch.propTypes = propTypes;

Switch.defaultProps = defaultProps;

export default Switch;
